<template>
  <div>
    <h3 class="print-color subtitle-border mb-2">{{ $t('report_preview.findings') }}：</h3>
    <div class="align-center highlight-area" v-if="findings">
      <div  align="center" class="pos-relative">
        <img src="/img/colon-preview-img.png" alt="" />
        <div
          class="highlight-point"
          :class="`highlight-${getLocation(value)}`"
          v-for="(value, key) in findings"
          :key="'highlight'+value.id"
          v-if="getLocation(value) !== null"
        >
          <div class="highlight-inner-point">{{ key+1 }}</div>
        </div>
      </div>
      <ol class="pl-3" v-if="findings" >
        <li class="mb-2 font-weight-bold" v-for="(value, key) in findings" :key="key">
          {{ transI18n(value.name) }}
        </li>
      </ol>
    </div>
    <p v-else class="pl-3">{{ $t('common.nil') }}</p>
    <hr color="#B6BAC3" class="mb-2 mt-2" />
    <ul class="pl-3 mb-3" style="list-style: none;">
      <li v-for="(v, key) in findings" :key="v.id" class="mb-1">
        <FindingItemContent 
          :locationNumbers="getLocation(v, true)"
          :finding="v" 
          :index="key+1" 
          :images="getAllImages" 
          :imgArrange="imgArrange" 
          isColonReport
        />
      </li>
      <li class="mb-1">
        <FindingOtherImages 
          :findings="findings" 
          :images="getAllImages" 
          :imgArrange="imgArrange" 
        />
      </li>
    </ul>
  </div>
</template>

<script>
import FindingItemContent from '@/components/commons/FindingItemContent.vue'
import { mapGetters, mapActions } from 'vuex'
import FindingOtherImages from '@/components/commons/FindingOtherImages.vue'
import { findMatchI18n } from '@/utils/findMatchI18n'
import { getLocationByLesionsObservation } from '@/utils/finding'
export default {
  name: 'FindingInfoByOrder',
  props: {
    findings: {
      type: Array,
      default: () => [],
    },
    imgArrange: {
      type: Number,
      default: 3
    }
  },
  components: {
    FindingItemContent,
    FindingOtherImages
  },
  data() {
    return {
      /*
      1. terminal ileum
      2. ileocecal valve
      3. appendix orifice
      4. cecum
      5. ascending colon
      6. hepatic flexure
      7. transverse colon
      splenic flexure
      descending colon
      sigmoid colon
      RS junction
      rectum
      Anus
      all segments of colon
      anastomosis
      anal retroflex
      */
      locationMap: {
        1: 'terminal ileum',
        2: 'ileocecal valve',
        3: 'appendix orifice',
        4: 'cecum',
        5: 'ascending colon',
        6: 'hepatic flexure',
        7: 'transverse colon',
        8: 'splenic flexure',
        9: 'descending colon',
        10: 'sigmoid colon',
        11: 'rs junction',
        12: 'rectum',
        13: 'anus',
        14: 'all segments of colon',
        15: 'anastomosis',
        16: 'anal retroflex',
      } 
    }
  },
  methods: {
    getLocation(finding, multiple = false) {
      return getLocationByLesionsObservation(finding, this.locationMap, multiple)
    },
    transI18n(text) {
      return findMatchI18n(text)
    }
  },
  computed: {
    ...mapGetters('examinations', ['getExaminationData']),
    getAllImages() {
      if (this.getExaminationData && this.getExaminationData.all) {
        return this.getExaminationData.all.sort((a, b) => b.id - a.id)
      }
      return []
    },
    
  },
}
</script>
<style lang="scss" scoped>
.highlight-area{
  display: grid;
  grid-template-columns: auto 1fr;
}
.highlight-point{
  position: absolute;
  top: 0;
  left: 0;
  width: 34px;
  height: 34px;
  display: flex;
  border-radius: 50%;
  background-color: rgba(13, 148, 136, 0.3);
  align-items: center;
  justify-content: center;
  > .highlight-inner-point{
    width: 26px !important;
    height: 26px !important;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    color: #ffffff;
    background-color: rgb(13, 148, 136)
  }
  /**575-522=53，所有的left 都要減53/2=26 */
  &.highlight-1{
    top:245px;
    left:180px;
  }
  &.highlight-2{
    top:245px;
    left:164px;
  }
  &.highlight-3{
    top:289px;
    left:202px;
  }
  &.highlight-4{
    top:289px;
    left:153px;
  }
  &.highlight-5{
    top:188px;
    left:132px;
  }
  &.highlight-6{
    top: 73px;
    left: 137px;
  }
  &.highlight-7{
    top: 114px;
    left: 252px;
  }
  &.highlight-8{
    top: 30px;
    left: 363px;
  }
  &.highlight-9{
    top: 173px;
    left: 363px;
  }
  &.highlight-10{
    top: 298px;
    left: 327px;
  }
  &.highlight-11{
    top: 266px;
    left: 357px;
  }
  &.highlight-12{
    top: 319px;
    left: 253px;
  }
  &.highlight-13{
    top: 398px;
    left: 253px;
  }
  &.highlight-14{
    top: 329px;
    left: 32px;
  }
  &.highlight-15{
    top: 348px;
    left: 32px;
  }
  &.highlight-16{
    top: 361px;
    left: 255px;
  }
}
</style>